export const SHARE_URL = {
    ok: 'https://connect.ok.ru/offer?url=',
    telegram: 'https://telegram.me/share/url?url=',
    vk: 'https://vk.com/share.php?url=',
    whatsapp: 'https://api.whatsapp.com/send?text=',
};

export const SOCIAL_NETWORKS = [
    {
        icon: 'telegram',
        name: 'telegram',
        url: SHARE_URL.telegram,
    },
    // {
    //     icon: 'whats-app',
    //     name: 'whatsapp',
    //     url: SHARE_URL.whatsapp,
    // },
    {
        icon: 'vk',
        name: 'vk',
        url: SHARE_URL.vk,
    },
    {
        icon: 'classmates',
        name: 'ok',
        url: SHARE_URL.ok,
    },
] as const;

export const WINDOW_OPEN_OPTIONS = 'noopener,noreferrer,width=630, height=435, top=100, left=100';
